import cx from 'classnames';
import React from 'react';
import styles from './loader-contextual.module.scss';
export const LoaderContextual = ({ loaderColor = 'blue', hideLoader = false, className, id, ...restProps }) => {
    const spinnerClassNames = cx(styles.loadingSpinner, styles[loaderColor], {
        [styles.hideLoader]: hideLoader,
    }, className);
    return React.createElement("div", { className: spinnerClassNames, id: id, ...restProps });
};
//# sourceMappingURL=loader-contextual.js.map